import { useState, useCallback } from "react";

const STORAGE_PREFIX = "pd_seen_";

export const useFirstVisit = (key) => {
  const storageKey = STORAGE_PREFIX + key;
  const [isFirstVisit, setIsFirstVisit] = useState(
    () => !localStorage.getItem(storageKey)
  );

  const dismiss = useCallback(() => {
    localStorage.setItem(storageKey, "1");
    setIsFirstVisit(false);
  }, [storageKey]);

  return [isFirstVisit, dismiss];
};

export default useFirstVisit;
